import { createSlice } from "@reduxjs/toolkit";
import { redirect } from "react-router-dom";
import {
  updateUser,
  getMyFriends,
  searchUsers,
  deleteProfilePicture,
  uploadCoverPhoto,
  uploadProfilePics,
  updatePassword,
  // updateProfileImages
} from "./userAction";
import store from "../store";
import apiInstance from "../../config/api";
import { getBlockUsers } from "../friend/friendAction";

const initialState = {
  muted:true,
  loading: false,
  photoUploading: false,
  userData: {},
  error: null,
  coverPhotoUrl: null,
  profilePhotoUrl: null,
  userDataLoading: false,
  userDataStatus: false,
  userDataError: null,
  userUpdateStatus: "idle",
  searchLoading: false,

  blockUserLoading: false,
  blockedUsers: [],
  blockUserError: null,

  searchHistory: [],
  searchResults: [],
  searchError: null,
  deleting: false,
  friendLoading: false,
  myFriends: [],
  friendError: null,
  updatingPassword: false,
};


export const addContentToExistingArray = (incomingContent, existingArray) => {
  incomingContent.forEach((item) => {

    const existingIndex = existingArray.findIndex((existingItem) =>
      existingItem.userId === item.userId
    );

    if (existingIndex !== -1) {
      existingArray[existingIndex] = item;
    } else {
      existingArray.push(item);
    }
  });
};

export const getUser = async ({ request }) => {
  try {
    if (!store.getState().user.userData.userId) {
      const apiResponse = await apiInstance.get("/api/user/user-details")
      const response = apiResponse.data
      if (response.status === "success") {
        store.dispatch(setUser(response.user))
        return null;
      } else {
        throw new Error(response.message);
      }
    } else {
      return null
    }
  } catch (error) {
    if (error?.status === 401 || error?.response?.status === 401) {
      const { pathname, search } = new URL(request.url);
      if (pathname === "/") return null;
      return redirect(`/login?next=${encodeURIComponent(pathname + search)}`);
    }
    throw new Error(error.message);
  }
}

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {

    toggleMute(state, action) {
      state.muted = action.payload
    }, 

    setUser(state, action) {
      // console.log('user settteds')
      state.userData = action.payload

      if (state.userData && state.userData.coverPhoto && state.userData.coverPhoto.length > 0) {
        // const lastIndex = state.user.coverPhoto.length - 1;
        state.coverPhotoUrl = state.userData.coverPhoto[0].photoPublicUrl;
      } else {
        state.coverPhotoUrl = initialState.coverPhotoUrl
      }
      if (state.userData && state.userData.profilePhoto && state.userData.profilePhoto.length > 0) {
        // const lastIndex = state.user.profilePhoto.length - 1;
        state.profilePhotoUrl = state.userData.profilePhoto[0].photoPublicUrl;
      } else {
        state.profilePhotoUrl = initialState.profilePhotoUrl
      }

    },
    resetUpdate: (state) => {
      state.userDataStatus = initialState.userDataStatus;
    },
    setSearchLoading: (state) => {
      state.searchLoading = true;
    },
    setSearchSuccess: (state, action) => {
      state.searchLoading = false;
      state.searchResults = action.payload;
    },
    setSearchError: (state, action) => {
      state.searchLoading = false;
      state.searchError = action.payload;
    },

    updatePostCount: (state, action) => { 
      const { actionType } = action.payload
      if (actionType === 'add') {
        state.userData.postsCount = (state.userData.postsCount || 0) + 1
      } else if (actionType === 'remove') {
        state.userData.postsCount = Math.max(0, (state.userData.postsCount || 0) - 1)
      }
    },

    updateReelsCount: (state, action) => {
      const { actionType, count = 1 } = action.payload
      
      // Initialize reelsCount if it doesn't exist
      if (!state.userData.reelsCount) {
        state.userData.reelsCount = 0;
      }
      
      if (actionType === 'add') {
        state.userData.reelsCount += 1
      } else if (actionType === 'delete') {
        state.userData.reelsCount = Math.max(0, state.userData.reelsCount - 1)
      } else if (actionType === 'deleteAll') {
        state.userData.reelsCount = Math.max(0, state.userData.reelsCount - count)
      }
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(updateUser.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateUser.fulfilled, (state, action) => {
        state.loading = false;
        state.userData = {...state.userData, ...action?.payload};
        state.userDataStatus = "success";
      })
      .addCase(updateUser.rejected, (state, action) => {
        state.loading = false;
        state.userDataError = action.error.message;
      });

    builder
      .addCase(uploadProfilePics.pending, (state) => {
        state.photoUploading = true
      })
      .addCase(uploadProfilePics.fulfilled, (state, action) => {
        state.photoUploading = false
        state.profilePhotoUrl = action.payload
      })
      .addCase(uploadProfilePics.rejected, (state) => {
        state.photoUploading = false
      })

    builder
      .addCase(uploadCoverPhoto.pending, (state) => {
        state.photoUploading = true
      })
      .addCase(uploadCoverPhoto.fulfilled, (state, action) => {
        state.photoUploading = false
        state.coverPhotoUrl = action.payload
      })
      .addCase(uploadCoverPhoto.rejected, (state) => {
        state.photoUploading = false
      })

    builder
      .addCase(getMyFriends.pending, (state) => {
        state.friendLoading = true
      })
      .addCase(getMyFriends.fulfilled, (state, action) => {
        state.friendLoading = false
        state.myFriends = action.payload
      })
      .addCase(getMyFriends.rejected, (state, action) => {
        state.friendLoading = false
        state.friendError = action.error.message
      })
    
    builder
      .addCase(getBlockUsers.pending, (state) => {
        if (state.blockUserError) {
          state.blockUserError = null
        }
        state.blockUserLoading = true
      })
      .addCase(getBlockUsers.fulfilled, (state, action) => {
        state.blockUserLoading = false
        state.blockedUsers = action.payload
      })
      .addCase(getBlockUsers.rejected, (state, action) => {
        state.blockUserLoading = false
        state.blockUserError = action.error.message
      })

    builder
      .addCase(deleteProfilePicture.pending, (state) => {
        state.deleting = true;
        state.error = null;
      })
      .addCase(deleteProfilePicture.fulfilled, (state, action) => {
        state.deleting = false;
        // Update state after successful deletion if needed
        // For example, reset profile photo URL or any relevant data
        state.profilePhotoUrl = null;
        if (state.userData) {
          state.userData.profilePhoto = [];
        }
      })
      .addCase(deleteProfilePicture.rejected, (state, action) => {
        state.deleting = false;
        state.error = action.error.message;
        // Handle error state management if needed
      });

    builder
      .addCase(updatePassword.pending, (state) => {
        state.updatingPassword = true
      })
      .addCase(updatePassword.fulfilled, (state, action) => {
        state.updatingPassword = false
      })
      .addCase(updatePassword.rejected, (state, action) => {
        state.updatingPassword = false
      })

    builder
      .addCase(searchUsers.pending, (state) => {
        state.searchLoading = true;
        state.searchError = null;
      })
      .addCase(searchUsers.fulfilled, (state, action) => {
        state.searchLoading = false;
        state.searchResults = action.payload;
        addContentToExistingArray(state.searchResults, state.searchHistory)
      })
      .addCase(searchUsers.rejected, (state, action) => {
        state.searchLoading = false;
        state.searchResults = [];
        state.searchError = action.error.message;
      });
  },
});

export const {
  setUser,
  resetUpdate,
  setSearchLoading,
  setSearchSuccess,
  setSearchError,
  updatePostCount,
  updateReelsCount,
  toggleMute
} = userSlice.actions;
export default userSlice.reducer;